import { render, staticRenderFns } from "./QuestionDialog.vue?vue&type=template&id=67f4da27"
import script from "./QuestionDialog.vue?vue&type=script&lang=js"
export * from "./QuestionDialog.vue?vue&type=script&lang=js"
import style0 from "./QuestionDialog.vue?vue&type=style&index=0&id=67f4da27&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports